import clsx from 'clsx';
import { Typography } from 'core/Typography';
import React, { ReactNode } from 'react';

import { AsideContentType } from '~/components/features/cases/RenessansBank/content-blocks';
import styles from '~/components/features/cases/RenessansBank/styles.module.sass';

type ContentBlockProps = {
    children: ReactNode;
    title: string;
    aside?: boolean;
    asideContent?: AsideContentType[];
    className?: string;
    titleClassName?: string;
    asideClassName?: string;
};

const ContentBlock = ({
    title,
    aside,
    asideContent,
    className,
    children,
    titleClassName,
    asideClassName,
}: ContentBlockProps) => {
    return (
        <>
            <Typography variant="h2" className={clsx('max-w-[920px] mb-6', titleClassName)}>
                {title}
            </Typography>
            <div
                className={clsx(
                    'max-w-[920px] w-full flex-col flex gap-6  xl-tablet:gap-[43px] ' +
                        'xl-tablet:flex-row  ',
                    aside && 'w-full max-w-none',
                    className
                )}
            >
                <div className="w-full flex flex-col gap-6 xl-tablet:min-w-4/6   ">
                    <div className="max-w-[920px]! flex flex-col gap-5">{children}</div>
                </div>
                {aside && asideContent && (
                    <aside
                        className={clsx(
                            'max-w-[440px] flex flex-col gap-6 xl-tablet:gap-[43px] xl-tablet:max-w-2/6 w-full' +
                                'mobile:mb-0 mb-12',
                            asideClassName
                        )}
                    >
                        {asideContent.map(({ content, id }) => {
                            return (
                                <div key={id} className={styles.asideLeftBorder}>
                                    <Typography variant="aside">{content}</Typography>
                                </div>
                            );
                        })}
                    </aside>
                )}
            </div>
        </>
    );
};

export default ContentBlock;
